export default __webpack_public_path__ + "static/media/Sagaris of the Twelfth Dynasty.c7a930f8.jpg";